import { css } from "styled-jsx/css";

export default css`
  .tabs {
    display: flex;
    margin-bottom: 12px;
    overflow-x: auto;
  }

  .tab {
    min-width: unset;
    background-color: transparent;
    padding: 6px 20px;
    border: 1px solid #949494;
    color: #949494;
    font-family: 'Roboto-Medium';
    font-size: 13px;
    letter-spacing: 0;
    line-height: 20px;
  }

  .tab:first-child {
    border-left-width: 1px;
    border-radius: 2px 0 0 2px;
  }

  .tab:last-child {
    border-radius: 0 2px 2px 0;
  }

  .selected-tab {
    background-color: #950810;
    color: #e4e4e4;
    border-color: #242424;
  }
`;
